module.exports = __webpack_public_path__ + "static/sponsor-09-ebbadfa3e9932d7741c391d8aa8f9cec.jpg";